<template>
  <v-container
    fill-height
    fluid
    class="background"
    style="max-height: 100vh;">
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        md3>
        <v-card
          min-height="200px"
          class="elevation-12">
          <v-toolbar color="heron_toolbar">
            <v-avatar
              color="tranparent"
              size="70">
              <img src="../assets/img/energy-control.png" >
            </v-avatar>
            <v-toolbar-title
              class="toolbar_text--text"
            >Energy Control</v-toolbar-title
            >
            <v-spacer />
            <img
              src="../assets/img/heron_icon.svg"
              width="70" >
          </v-toolbar>

          <v-card-title class="card-title">
            <v-icon
              size="60"
              color="heron_success"
              class="pr-4"
            >mdi-account-check</v-icon
            >
            Οι όροι χρήστη ενημερώθηκαν!</v-card-title
            >
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'HERON Energy Control'
    }
  }
}
</script>

<style scoped>
.background {
  background: url("../assets/img/heron_background_new.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.card-title {
  font-size: 20px;
}
.custom-card {
  height: 300px;
}
.v-toolbar__title {
  font-size: 1.5rem !important;
}
</style>
